export const SCHOOL_DPA_ONLY_PLAN_KEY = 'school_dpa_only';

export type LicenseWithPlanKey = {
  plan: { key: string };
};

export const isDpaOnlyLicense = (license: LicenseWithPlanKey): boolean =>
  license.plan.key === SCHOOL_DPA_ONLY_PLAN_KEY;
